import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import logoComplete from "../../assets/images/logo-copmpleto.png";

import BannerLogin from './BannerLogin';
import Rodape from './Rodape';

import { Row, Col, CardBody, Card, Alert, Form, FormFeedback } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useLocation } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { isLoading, loginUser, loginUserByToken } from "../../store/actions";

import config from "../../config";
import { useCookies } from "react-cookie";
import BizinBackend from "../../helpers/bizin_helper";
import { decode } from 'js-base64';
import useGetCsrfToken from "../../Hooks/useGetCsrfToken";

const Login = props => {
  document.title = "Login | Bizin";

  const { search } = useLocation()

  const [messageError, setmessageError] = useState(null)

  const [cookies, setCookie] = useCookies(['_csrf_token']);
  const csrfToken = useGetCsrfToken();
  const dispatch = useDispatch();
  const { userProfile, isModalPage, isIframePage, isLoadingGlobal } = useSelector(state => ({
    userProfile: state.login.user,
    isModalPage: state.Layout.isModalPage,
    isIframePage: state.Layout.isIframePage,
    isLoadingGlobal: state.Layout.isLoading
  }));

  const [showPassword, setShowPassword] = useState(false);
  const [showPage, setShowPage] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
      password: '',
      _csrf: csrfToken
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password")
    }),
    onSubmit: async (values) => {
      const payload = { ...values };
      dispatch(isLoading(true));
      dispatch(loginUser(payload, props.router.navigate));
    }
  });

  const { error } = useSelector(state => ({
    error: state.login.error,
  }));

  const getCsrf = async () => {
    try {
      const { csrfToken } = await BizinBackend.getCsrfToken();
      setCookie("_csrf_token", csrfToken);
    } catch (error) {
      console.error("Error fetching CSRF token:", error);
    }
  };

  const getUserByToken = async (token, csrf_token) => {
    const data = await BizinBackend.executeProcedure(
      { 1: decode(token) }, 
      'FRONT_Token_Acesso_Verificar', 
      csrfToken || csrf_token
    );
    
    if(data[0] && data[0]?.statusCode == 200){
      const { Email } = data[0]      
      dispatch(loginUserByToken({
        email: Email,
        token: decode(token),
        _csrf: csrfToken || csrf_token
      }, props.router.navigate));
    }else{
      setmessageError(data[0]?.message || "Token de redirecionamento inválido.")
      setShowPage(true)
      dispatch(isLoading(false))
    }
  }

  useEffect(() => {
    if(!isIframePage) getCsrf();
    
    if (userProfile) {
      props.router.navigate('/');
    }

    document.body.className = "bg-pattern";
    return () => {
      document.body.className = "";
    };
  }, []);

  useEffect(() => {
    const params = (localStorage.getItem('UrlOriginNoAuth')) ? new URLSearchParams(localStorage.getItem('UrlOriginNoAuth').split('?')[1]) : new URLSearchParams(search)
    let cookie = csrfToken || params.get("_csrf")
        
    if(params.size && params.get('token') && cookie){
      localStorage.removeItem("_csrf_token");
      localStorage.setItem("_csrf_token", cookie);
      dispatch(isLoading(true))
      getUserByToken(params.get('token'), cookie)
    }else{
      setShowPage(true)
    }
  }, [cookies]);

  if(!showPage || isLoadingGlobal){
    return (
      <div className="d-flex align-items-center justify-content-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only"></span>
        </div>
      </div>
    )
  }else{
    if(isIframePage && (error || messageError) || (window.self !== window.top)){
      return (
        <div>
          <Alert color="danger">
            {error || messageError} {" - Tente novamente, recarregando a página."}
          </Alert>
        </div>
      )
    }
    return (
      <React.Fragment>
        <Row className="h-100 m-0">
          <Col lg={4} md={6} className="d-flex flex-column justify-content-between col-login">
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ flexGrow: 1 }}
            >
              <Card className="card-login h-100 w-100 pt-md-3">
                <CardBody className="text-center d-flex flex-column ">
  
                  <div className="text-center d-flex justify-content-center align-items-center flex-grow-1">
                    <Link to="/">
                      <img
                        src={logoComplete}
                        alt=""
                        className="auth-logo mx-auto logo-login"
                      />
                    </Link>
                  </div>
  
                  <div className="flex-grow-1 flex-column d-flex">
                    <div className="d-flex flex-column">
                        <p className="texto1-login">
                          Bem-vindo à maior plataforma para MatCon do Brasil!
                        </p>
  
                        {error || messageError ? (
                          <Alert color="danger"><div>{error || messageError}</div></Alert>
                        ) : null}
  
                        <Form
                          className="form-horizontal"
                          onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                          }}
                        >
                          {/* Input de email */}
                          <div className="d-grid my-md-3 my-4">
                            <div className="input-group">
                              <div className="input-group-text input-icone-login">
                                <i className="fas fa-user azul-claro"></i>
                              </div>
                              <input
                                name="email"
                                type="email"
                                className="form-control input-login"
                                placeholder="usuario@empresa.com.br"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={validation.touched.email && validation.errors.email}
                              />
                              {validation.touched.email && validation.errors.email && (
                                <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                              )}
                            </div>
                          </div>
  
                          {/* Input de senha */}
                          <div className="mb-4">
                            <div className="input-group">
                              <div className="input-group-text input-icone-login">
                                <i className="fas fa-lock azul-claro"></i>
                              </div>
                              <input
                                name="password"
                                type={showPassword ? "text" : "password"}
                                className="form-control input-login"
                                placeholder="Senha"
                                value={validation.values.password || ""}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.password && validation.errors.password}
                              />
                              <div
                              
                                className="input-group-text bt-icone-login"
                                style={{ border: "none", background: "none", cursor: "pointer" }}
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                <i className={showPassword ? "fas fa-eye" : "far fa-eye-slash"}></i>
                              </div>
                              {validation.touched.password && validation.errors.password && (
                                <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                              )}
                            </div>
                          </div>
  
                          <div className="d-grid mt-4">
                            <button
                              className="btn btn-primary waves-effect waves-light"
                              type="submit"
                            >
                              ENTRAR
                            </button>
                          </div>
                        </Form>
                        <Link to="/BI_AC0002" className="text-light-blue-01 font-size-14 mt-3">
                          Esqueci minha senha
                        </Link>
                      </div>
                  </div>
                </CardBody>
              </Card>
            </div>
  
            <div className="text-center p-3">
              <Rodape />
            </div>
          </Col>
  
          <Col
            className="d-flex align-items-center justify-content-center bg-dark col-login p-0 d-none d-lg-block"
          >
            <BannerLogin />
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
